import mergeConfig from 'coact/config/mergeConfig'

import clientConfig from './clientConfig.js'

const config = {
  models: {
    invoices: {
      views: {
        issuer: clientConfig,
      },
    },
  },
}

export default fullConfig => mergeConfig(fullConfig, config)
